import Alpine from 'alpinejs';
import {marquee} from '@groupthought/analog-ui/alpine';

Alpine.plugin(marquee);
